import apiClient from '../apiClient';
import { GET_REGION_BY_ID_URL } from '../apiUrl';

const getRegionByIdApi = Id => {
  return apiClient.get(GET_REGION_BY_ID_URL(Id));
};

export default getRegionByIdApi;
